import axios from 'axios';
import * as qs from 'qs';
import resolvePath from 'utils/resolvePath';
// Action
const GET_COUNTRIES_REQUEST = 'locations/getCountriesRequest';
const GET_COUNTRIES_SUCCESS = 'locations/getCountriesSuccess';
const GET_COUNTRIES_FAILURE = 'locations/getCountriesFailure';
const GET_TIMEZONES_REQUEST = 'locations/getTimezonesRequest';
const GET_TIMEZONES_SUCCESS = 'locations/getTimezonesSuccess';
const GET_TIMEZONES_FAILURE = 'locations/getTimezonesFailure';
// Action Creator
export const getCountriesRequest = () => {
    return {
        type: GET_COUNTRIES_REQUEST,
    };
};
export const getCountriesSuccess = (countries) => {
    return {
        payload: {
            countries,
        },
        type: GET_COUNTRIES_SUCCESS,
    };
};
export const getCountriesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_COUNTRIES_FAILURE,
    };
};
export const getCountries = () => (dispatch) => {
    dispatch(getCountriesRequest());
    return axios
        .get(resolvePath.api('locations/countries'))
        .then((response) => dispatch(getCountriesSuccess(response.data)))
        .catch((error) => {
        dispatch(getCountriesFailure(error));
        throw error;
    });
};
export const getTimezonesRequest = () => {
    return {
        type: GET_TIMEZONES_REQUEST,
    };
};
export const getTimezonesSuccess = (timezones) => {
    return {
        payload: {
            timezones,
        },
        type: GET_TIMEZONES_SUCCESS,
    };
};
export const getTimezonesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TIMEZONES_FAILURE,
    };
};
export const getTimezones = (country) => (dispatch) => {
    dispatch(getTimezonesRequest());
    const request = {
        country,
    };
    return axios
        .get(`${resolvePath.api('locations/timezones')}?${qs.stringify(request)}`)
        .then((response) => dispatch(getTimezonesSuccess(response.data)))
        .catch((error) => {
        dispatch(getTimezonesFailure(error));
        throw error;
    });
};
const initialState = {
    countries: {
        data: [],
        meta: {
            default_country: '',
            default_timezone: '',
        },
    },
    error: null,
    isFetching: false,
    timezones: {
        data: [],
        meta: {
            default_country: '',
            default_timezone: '',
        },
    },
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_COUNTRIES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_COUNTRIES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { countries: Object.assign({}, action.payload.countries), isFetching: false });
        }
        case GET_COUNTRIES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_TIMEZONES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_TIMEZONES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, timezones: Object.assign({}, action.payload.timezones) });
        }
        case GET_TIMEZONES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
